import { Link } from "react-router-dom";

/**
 * variant:
 *  - "landing": logo links to /, copy + 3 legal links
 *  - "branded": logo links to /, "Powered by ATTOMO" copy block + 3 legal links (Coming Soon)
 *  - "legal":   logo as image, plain copy text, 3 legal cross-links only (legal pages)
 *  - "bare":    logo as image, plain copy text — no links anywhere
 */
export default function Footer({ variant = "landing" }) {
  const logo = (
    <img
      src="/assets/logo-white.svg"
      alt="Random College"
      className="footer-logo-img"
      style={{ height: 32, width: "auto", opacity: 0.7 }}
    />
  );

  return (
    <footer className="rc-footer">
      <Link to="/" className="rc-logo">
        {logo}
      </Link>

      {/* {variant === 'branded' ? (
        <div className="footer-copy-block">
          <p className="footer-copy">© 2026 Random College</p>
          <p className="footer-powered">
            Powered by{' '}
            <a href="https://attomo.digital" target="_blank" rel="noopener noreferrer">
              ATTOMO
            </a>
          </p>
        </div>
      ) : (
        <p className="footer-copy">© 2026 Random College · skool.com/randomcollege</p>
      )} */}

      {variant !== "bare" && (
        <div className="footer-legal">
          <Link to="/privacidad">Política de Privacidad</Link>
          <span className="footer-legal-sep">·</span>
          <Link to="/terminos">Términos y Condiciones</Link>
          <span className="footer-legal-sep">·</span>
          <Link to="/cookies">Política de Cookies</Link>
        </div>
      )}
    </footer>
  );
}
